import { usePermissions } from '@/__core/permissions';

export const useOrderProgressPermissions = () => {
  const { hasPermission } = usePermissions();

  return {
    canRead: hasPermission('orders.orderprogress', 'read'),
    canCreate: hasPermission('orders.orderprogress', 'create'),
    canUpdate: hasPermission('orders.orderprogress', 'update'),
    canDelete: hasPermission('orders.orderprogress', 'delete'),
  };
};

export default useOrderProgressPermissions;
